import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';

export const jqTypes = [
  {
    name: i18n.t('pc_gwnl_lbl_dimension_required').d('门槛项'),
    id: 1
  },
  {
    name: i18n.t('pc_gwnl_lbl_dimension_mapping').d('匹配项'),
    id: 2
  },
  {
    name: i18n.t('pc_gwnl_lbl_dimension_veto').d('否决项'),
    id: 3
  },
  {
    name: i18n.t('pc_gwnl_lbl_dimension_bonus').d('加分项'),
    id: 4
  },
  {
    name: i18n.t('pc_biz_te_lbl_no').d('无'),
    id: 0
  }
];
